// Shared smooth-scroll-to-section helper. Applies an offset equal to the
// fixed navbar height so target sections always land flush below the nav
// with no sliver of the previous section peeking through.
export function scrollToSection(href) {
  if (typeof window === "undefined") return;
  const el = typeof href === "string" ? document.querySelector(href) : href;
  if (!el) return;
  const nav = document.querySelector('[data-testid="navbar"]');
  const navH = nav ? nav.getBoundingClientRect().height : 80;
  const y = el.getBoundingClientRect().top + window.scrollY - navH;
  window.scrollTo({ top: y, behavior: "smooth" });
}
